import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import theme from '../../common/theme';

const ScrollViewStyles = () => {
  return useMemo(
    () =>
      StyleSheet.create({
        scrollbarTrack: {
          position: 'absolute',
          width: 4,
          top: 0,
          bottom: 0,
          right: 2,
          borderRadius: theme.radius.s,
          overflow: 'hidden',
        },
        scrollbarThumb: {
          width: 4,
          borderRadius: 2,
          backgroundColor: theme.colors.grey5,
        },
      }),
    [],
  );
};

export default ScrollViewStyles;
